import React, { FC } from 'react';
import { TableBody, TableRow, TableCell } from './ui/table';

interface TableSkeletonProps {
    columns: number;
    rows?: number;
}

export const TableSkeleton: FC<TableSkeletonProps> = ({ columns, rows = 5 }) => {
    return (
        <TableBody>
            {Array.from({ length: rows }).map((_, rowIndex) => (
                <TableRow key={rowIndex}>
                    {Array.from({ length: columns }).map((_, colIndex) => (
                        <TableCell key={colIndex}>
                            <div className="d-flex align-items-center">
                                {/* A gray box to mimic text.
                                   'animate-pulse' is a common utility, but if you don't have it,
                                   opacity-50 works well for a static skeleton.
                                */}
                                <div
                                    className="bg-light rounded"
                                    style={{
                                        height: '12px',
                                        width: colIndex === 0 ? '70%' : '100%', // First col usually wider
                                        minWidth: '50px',
                                        opacity: 0.6
                                    }}
                                ></div>
                            </div>
                        </TableCell>
                    ))}
                </TableRow>
            ))}
        </TableBody>
    );
};

